// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1yzWi","col":"CardReaderDesc_col__9DzJP","label":"CardReaderDesc_label__19SnK"};